/*
  Fashion PDP (sections/main-product.liquid):
    1. Similar products — fetches same-type products after load (AJAX)
       from the sources the section lists, and fills the rail.
    2. Recommended size — fills the fit banner from the shopper's
       remembered size (assets/vro-size-memory.js); stays hidden otherwise.
  The body-type card needs nothing here: it is decided server-side from the
  product's tags and rendered read-only.
*/
(function () {
  'use strict';

  var started = false;
  function start() {
    if (started) return;
    started = true;
    initSimilar();
    initFit();
  }

  /* ---------------- Similar products ---------------- */
  function initSimilar() {
    var box = document.querySelector('[data-pdp-similar]');
    if (!box) return;
    var rail = box.querySelector('[data-pdp-similar-rail]');
    if (!rail) return;

    var sources = (box.getAttribute('data-sources') || '').split('||').filter(Boolean);
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 8;
    var seen = {};
    seen[box.getAttribute('data-exclude') || ''] = true;

    var picked = [];
    var firstSource = '';
    var total = 0;
    var index = 0;

    function handleOf(card) {
      var h = card.getAttribute('data-vro-handle');
      if (h) return h;
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return null;
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    }

    function load(url) {
      return fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { return res.ok ? res.text() : ''; })
        .catch(function () { return ''; });
    }

    function next() {
      if (picked.length >= limit || index >= sources.length) return Promise.resolve();
      var url = sources[index++];
      return load(url).then(function (html) {
        if (html) {
          if (!firstSource && html.indexOf('feed-card') > -1) firstSource = url;
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var meta = holder.querySelector('[data-vro-pool]');
          if (!total && meta) total = parseInt(meta.getAttribute('data-vro-items'), 10) || 0;

          /* In stock first, otherwise keep the shelf's best-selling order. */
          var cards = Array.prototype.slice.call(holder.querySelectorAll('.feed-card'))
            .map(function (card, i) {
              var avail = card.getAttribute('data-vro-available');
              return { card: card, i: i, rank: avail === 'false' ? 1 : 0 };
            })
            .sort(function (a, b) { return a.rank - b.rank || a.i - b.i; });

          for (var c = 0; c < cards.length && picked.length < limit; c++) {
            var card = cards[c].card;
            var h = handleOf(card);
            if (!h || seen[h]) continue;
            seen[h] = true;
            card.removeAttribute('hidden');
            picked.push(card);
          }
        }
        return next();
      });
    }

    /* The shared ranking (assets/vro-similar.js), from what the product
       is — its menu kind, type and title — rather than the first three
       tags it happens to carry. The older source list stays as the way
       in only when that script or the product's config is missing. */
    var cfg = window.VroSimilar && window.VroSimilar.readConfig(box);
    var run = cfg
      ? window.VroSimilar.pick(cfg, { limit: limit }).then(function (r) {
          picked = r.cards;
          total = r.total;
          firstSource = r.url ? r.url + (r.url.indexOf('?') > -1 ? '&' : '?') + 'view=vro-personalize' : '';
          if (r.label) box.setAttribute('data-type-label', String(r.label).toLowerCase());
        })
      : next();

    run.then(function () {
      if (!picked.length) return;
      rail.innerHTML = '';
      picked.forEach(function (card) { rail.appendChild(card); });

      var countEl = box.querySelector('[data-pdp-similar-count]');
      var tpl = box.getAttribute('data-count-text') || '[count] from [total]';
      if (countEl) {
        countEl.textContent = tpl
          .replace(/\[count\]/g, String(picked.length))
          .replace(/\[total\]/g, String(Math.max(total, picked.length)));
      }

      var why = box.querySelector('[data-pdp-similar-why]');
      var whyLine = box.querySelector('[data-pdp-similar-why-line]');
      var line = whyText(box, picked);
      if (why && whyLine && line) {
        whyLine.textContent = line;
        why.hidden = false;
      }

      /* "More like this →" — the web comp's closing tile, to the first
         shelf the row was filled from (without the fragment view). */
      var moreLabel = (box.getAttribute('data-more-label') || '').trim();
      if (moreLabel && firstSource) {
        var more = document.createElement('a');
        more.className = 'pdp-more-like';
        more.href = firstSource.replace(/([?&])view=vro-personalize(&|$)/, function (m, a, b) { return b ? a : ''; }).replace(/[?&]$/, '');
        more.innerHTML = '<svg width="24" height="24" viewBox="0 0 28 28" fill="none" aria-hidden="true"><path d="M12.2825 8.32959C13.1923 6.6654 13.6473 5.83331 13.9951 5.83331C14.343 5.83331 14.7979 6.6654 15.7078 8.32959C16.6442 10.0425 17.8957 11.3087 19.657 12.2733C21.3241 13.1863 22.1576 13.6427 22.1576 13.991C22.1576 14.3392 21.3235 14.7962 19.6554 15.7101C17.9443 16.6475 16.6794 17.9004 15.7157 19.6636C14.8037 21.3322 14.3477 22.1666 13.9998 22.1666C13.652 22.1666 13.1955 21.3318 12.2825 19.6618C11.3461 17.9489 10.0945 16.6827 8.33317 15.7181C6.66053 14.8021 5.82422 14.344 5.82422 13.9958C5.82422 13.6474 6.66053 13.1894 8.33317 12.2733C10.0945 11.3087 11.3461 10.0425 12.2825 8.32959Z" fill="#0080FF" stroke="#0080FF" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        var words = document.createElement('span');
        words.textContent = moreLabel;
        var arrow = document.createElement('span');
        arrow.className = 'pdp-more-like-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '\u2192';
        words.appendChild(arrow);
        more.appendChild(words);
        rail.appendChild(more);
      }

      box.hidden = false;
      try {
        document.dispatchEvent(new CustomEvent('vro:cards:added', { detail: { container: rail }, bubbles: true }));
      } catch (e) { /* ignore */ }
    });
  }

  /* The chip's line, from the cards in the row — never a fixed claim.
     Order: a fit the row shares with this product ("5 slim fit t-shirts
     like this one"), else a single brand ("More t-shirts from Powerlook"),
     else brands and price range ("T-shirts from 6 brands, ₹499–₹1,999"). */
  var FITS = ['slim fit', 'regular fit', 'relaxed fit', 'oversized fit', 'oversized', 'loose fit', 'straight fit', 'skinny fit', 'boxy fit', 'muscle fit', 'comfort fit'];

  function fitOf(text) {
    text = String(text || '').toLowerCase();
    for (var i = 0; i < FITS.length; i++) {
      if (text.indexOf(FITS[i]) > -1) return FITS[i] === 'oversized' ? 'oversized fit' : FITS[i];
    }
    return '';
  }

  function titleCase(s) {
    return String(s || '').replace(/\b([a-z])/g, function (m) { return m.toUpperCase(); });
  }

  function capFirst(s) {
    s = String(s || '');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function rupees(paise) {
    var n = Math.round(paise / 100);
    try { return '\u20B9' + n.toLocaleString('en-IN'); } catch (e) { return '\u20B9' + n; }
  }

  function whyText(box, cards) {
    var type = box.getAttribute('data-type-label') || 'styles';
    var myFit = fitOf(box.getAttribute('data-fit'));

    var brands = {};
    var brandCount = 0;
    var prices = [];
    var sameFit = 0;
    cards.forEach(function (card) {
      var v = (card.getAttribute('data-vro-vendor') || '').trim();
      if (v && !brands[v]) { brands[v] = true; brandCount++; }
      var p = parseInt(card.getAttribute('data-vro-price'), 10);
      if (p > 0) prices.push(p);
      if (myFit) {
        var cardFit = fitOf((card.getAttribute('data-vro-fit') || '') + ' ' + (card.getAttribute('data-vro-title') || ''));
        if (cardFit === myFit) sameFit++;
      }
    });

    var range = '';
    if (prices.length) {
      var lo = Math.min.apply(null, prices);
      var hi = Math.max.apply(null, prices);
      range = lo === hi ? rupees(lo) : rupees(lo) + '\u2013' + rupees(hi);
    }
    var brandText = brandCount === 1
      ? titleCase(Object.keys(brands)[0])
      : brandCount + ' brands';

    var tpl = (box.getAttribute('data-why-text') || '').trim();
    if (tpl) {
      return tpl
        .replace(/\[type\]/g, type)
        .replace(/\[fit\]/g, myFit || '')
        .replace(/\[brands\]/g, brandCount ? brandText : '')
        .replace(/\[price_range\]/g, range)
        .replace(/\[count\]/g, String(cards.length))
        .replace(/\s{2,}/g, ' ')
        .trim();
    }

    if (myFit && sameFit >= 2) {
      return sameFit + ' ' + myFit + ' ' + type + ' like this one';
    }
    if (brandCount === 1) {
      return 'More ' + type + ' from ' + brandText + (range ? ', ' + range : '');
    }
    if (brandCount > 1) {
      return capFirst(type) + ' from ' + brandText + (range ? ', ' + range : '');
    }
    return range ? capFirst(type) + ' in ' + range : '';
  }

  /* ---------------- Recommended size ---------------- */
  function initFit() {
    var card = document.querySelector('[data-pdp-fit]');
    if (!card || !window.VroSizeMemory) return;
    /* A product that answers one of the PDP quizzes (Topwear, Bottomwear,
       Footwear, letter sizes) is recommended from that quiz alone, by
       assets/vro-pdp-quiz.js. This older remembered-size line stays for
       sized products outside those. */
    if (card.hasAttribute('data-quiz-kind') && window.VroPdpQuiz) return;

    var sizes = (card.getAttribute('data-sizes') || '').split('|').filter(Boolean);
    var brand = card.getAttribute('data-brand') || '';
    var garment = card.getAttribute('data-garment') || '';
    var rec = window.VroSizeMemory.recommend(sizes, brand, { garment: garment });
    if (!rec || !rec.value) return;

    var size = rec.value;
    var from = rec.brand || '';
    /* What they actually told us, where that is not what this product
       calls it — a letter on a product numbered by the chest, or a number
       this one does not stock. The line says both, so the recommendation
       shows its working rather than asserting a size they never gave. */
    var said = rec.said || '';

    var headingTpl = card.getAttribute('data-heading') || '';
    var title = headingTpl.indexOf('[size]') > -1
      ? headingTpl.replace(/\[size\]/g, size)
      : 'Recommended Size is ' + size;

    var textTpl = card.getAttribute('data-text') || '';
    var text;
    if (textTpl.indexOf('[size]') > -1 && (textTpl.indexOf('[brand]') === -1 || from)) {
      text = textTpl.replace(/\[size\]/g, size).replace(/\[brand\]/g, from);
    } else if (rec.how === 'converted' && said) {
      text = 'You wear ' + article(said) + said + ', which is ' + article(size) + size + ' in this cut';
    } else if (rec.how === 'nearest' && said) {
      text = 'You wear ' + article(said) + said + ' \u2014 ' + size + ' is the closest this one comes in';
    } else if ((rec.source === 'brand' || rec.source === 'product') && from) {
      text = 'Because you wear ' + article(size) + size + ' in ' + from + ' this will fit you perfectly';
    } else if (rec.source === 'filter') {
      text = 'Because you shopped size ' + size + ' earlier, this should fit you well';
    } else {
      text = 'Because you picked ' + size + ' in the size quiz, this should fit you well';
    }

    var t = card.querySelector('[data-pdp-fit-title]');
    var p = card.querySelector('[data-pdp-fit-text]');
    if (t) t.textContent = title;
    if (p) p.textContent = text;
    card.hidden = false;
  }

  /* The size quiz on this page (assets/vro-pdp-quiz.js) has just saved an
     answer: show the recommendation it makes without a reload. */
  document.addEventListener('vro:size-quiz:done', function () { initFit(); });

  /* "an L", "an XL", "an M", "an S" — but "a 32", "a 2XL". */
  function article(size) {
    return /^(XS|S|M|L|XL|XXL|XXXL)$/i.test(String(size).trim()) ? 'an ' : 'a ';
  }

  if (document.readyState === 'complete') start();
  else {
    document.addEventListener('DOMContentLoaded', start);
    window.addEventListener('load', start);
  }
})();
